import { useEffect, useRef } from "react";
import { defined, Entity, PathGraphics, Color, StripeMaterialProperty, StripeOrientation, } from "cesium";
import { useCesium } from "../Contexts/Widget3DContext";
import { vfColour2RGB } from "./utils";
export const Orbit = ({ name, orbitPositions, trailTime = undefined, leadTime = undefined, orbitColor = vfColour2RGB("WHITE"), orbitPeriod = 0, }) => {
    const { isViewerLoaded, addEntity, removeEntity } = useCesium();
    const orbitEntity = useRef(null);
    const futureOrbitEntity = useRef(null);
    const addOrbit = () => {
        const orbitOptions = new Entity({
            id: `${name} orbit`,
            name: `${name} orbit`,
            position: orbitPositions,
            path: new PathGraphics({
                leadTime: 0,
                trailTime: trailTime ? trailTime : orbitPeriod / 2,
                width: 2,
                resolution: 1000,
                material: new Color(orbitColor.R / 255, orbitColor.G / 255, orbitColor.B / 255, orbitColor.A / 255),
            }),
        });
        return addEntity(orbitOptions);
    };
    const addFutureOrbit = () => {
        const futureOrbitOptions = new Entity({
            id: `${name} orbit future`,
            name: `${name} orbit future`,
            position: orbitPositions,
            path: new PathGraphics({
                leadTime: leadTime ? leadTime : orbitPeriod / 2,
                trailTime: 0,
                width: 2,
                resolution: 1000,
                material: new StripeMaterialProperty({
                    orientation: StripeOrientation.VERTICAL,
                    evenColor: new Color(orbitColor.R / 255, orbitColor.G / 255, orbitColor.B / 255, orbitColor.A / 255),
                    oddColor: new Color(0, 0, 0, 0),
                    repeat: 51,
                }),
            }),
        });
        return addEntity(futureOrbitOptions);
    };
    useEffect(() => {
        if (isViewerLoaded && defined(orbitPositions)) {
            (orbitEntity === null || orbitEntity === void 0 ? void 0 : orbitEntity.current) && removeEntity(orbitEntity.current);
            orbitEntity.current = addOrbit();
            futureOrbitEntity.current && removeEntity(futureOrbitEntity.current);
            futureOrbitEntity.current = addFutureOrbit();
        }
        return () => {
            (orbitEntity === null || orbitEntity === void 0 ? void 0 : orbitEntity.current) && removeEntity(orbitEntity.current);
            futureOrbitEntity.current && removeEntity(futureOrbitEntity.current);
        };
    }, [isViewerLoaded, orbitPositions, name, trailTime, leadTime, orbitPeriod]);
    return null;
};
//# sourceMappingURL=Orbit.js.map